export enum DefaultPath {
	HOME = "home/full/highlights",
	LIVE = "live/matches",
	/**
	 * Basic prematch with default data
	 * */
	PREMATCH = "sports/full",
	SEARCH = "search/full",
	/**
	 * This sets offer menu with segments
	 * */
	PREMATCH_OFFER = "sports/full/f",
	LIVE_UPCOMING = "live/upcoming",
	LIVE_STATIC_UPCOMING = "live/static-upcoming",
}
